import { render, staticRenderFns } from "./material-inventory-detail.vue?vue&type=template&id=b47d9006&scoped=true"
import script from "./material-inventory-detail.vue?vue&type=script&lang=js"
export * from "./material-inventory-detail.vue?vue&type=script&lang=js"
import style0 from "./material-inventory-detail.vue?vue&type=style&index=0&id=b47d9006&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b47d9006",
  null
  
)

export default component.exports